import React, { useState } from 'react';
import { Card, CardBody, Row, Col, Button } from "reactstrap";

import ProfileTabCard from './ProfileTabCard';
import styled from 'styled-components';
import ModalSignature from './ModalSignature';
import RenderNewsletters from './RenderNewsletters';
import ProfileTickets from './ProfileTickets';
import { useHistory } from 'react-router-dom';
import Manuals from './Manuals';
import ModalManual from './ModalManual';

const Profile = ({
    user,
    readingSigns,
    setReadingSigns,
    updates,
    trainingAssigned
}) => {

    const history = useHistory();
    const [modalSignature, setModalSignature] = useState(false);

    const trainingDue = Boolean(trainingAssigned && trainingAssigned.length);

    return (
        <Row>
            <Col lg={3} md={12} style={{ marginTop: '65px' }} className={'mb-2'}>
                <Card className='custom-opacity-card' style={{ borderRadius: '0.75rem' }}>
                    <img src={user.s_photo_link || '/assets/img/user.png'} className="img-thumbnail card-img social-profile-img" style={{ borderRadius: '0.75rem' }} />
                    <CardBody className='custom-card-transparent py-3 px-3' style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                        <Row className="text-muted text-right mb-2">
                            <Col md={12}>
                                {
                                    user.id &&
                                    <a href={`https://nam.delve.office.com/?u=${user.id}&v=work`} target={'blank'}>
                                        <i className="pr-3 far fa-edit"></i>
                                    </a>
                                }
                            </Col>
                        </Row>
                        <Row className='text-center'>
                            <Col md={12}>
                                <p className='mb-0'>{user.jobTitle}</p>
                                <p className='mb-0'>{user.department}</p>
                                <p>{user.s_unit}</p>
                            </Col>
                        </Row>
                        {
                            trainingDue && (
                                <div className={'bg-warning'}>
                                    <h4 className='hover' onClick={() => history.push('/EOS/Training/TrainingModule')}>Training Due <i className='fa-duotone fa-graduation-cap text-success' /></h4>
                                </div>
                            )
                        }
                        <Row>
                            <Col md={12}>
                                <Button onClick={() => setModalSignature(true)}>
                                    My Email Signature
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Manuals 

                />
                {/* <ProfileTickets /> */}
            </Col>

            <Col lg={8} md={12}>
                <Card className='custom-opacity-card' style={{ borderRadius: '0.75rem' }}>
                    <CardBody className='custom-card-transparent py-3 px-4' style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                        <ProfileTabCard
                            user={user}
                            updates={updates}
                            readingSigns={readingSigns}
                            setReadingSigns={setReadingSigns}
                        />
                    </CardBody>
                </Card>
                <Card className='custom-opacity-card mt-2' style={{ borderRadius: '0.75rem', height: '1000px' }}>
                    <CardBody className='custom-card-transparent py-3 px-4' style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                        <RenderNewsletters />
                    </CardBody>
                </Card>
            </Col>
            <ModalSignature 
                modal={modalSignature}
                setModal={setModalSignature}
                user={user}
            />
            <ModalManual 

            />
        </Row>
    );
}

export default Profile;

const FlexDiv = styled.div`
    & img {
        float: left;
    }
`;

const NameTitle = styled.p`
    margin-bottom: 0px;
`;

const BoldName = styled.span`
    font-weight: bold;
`;

const DataContainer = styled.div`
    float: right;
    margin-left: 50px;

    & p {
        margin-bottom: 0px;
    }
`;